import { Link } from "react-router-dom";

import salaBalowa from "src/assets/img/studio/sala-balowa.webp";
import salaKominkowa from "src/assets/img/studio/sala-kominkowa.webp";
import salaOgrodowa from "src/assets/img/studio/sala-ogrodowa.webp";
import salaTarasowa from "src/assets/img/studio/sala-tarasowa.webp";

import salaBalowaAlt from "src/assets/img/atelier/salaBalowa.webp";
import salaKominkowaAlt from "src/assets/img/atelier/salaKominkowa.webp";
import salaOgrodowaAlt from "src/assets/img/atelier/salaOgrodowa.webp";
import salaTarasowaAlt from "src/assets/img/atelier/salaTarasowa.webp";

import obzerwujLight from "src/assets/img/obzerwuj/light.webp";
import facebookSvg from "src/assets/img/obzerwuj/facebook.svg";
import instagramSvg from "src/assets/img/obzerwuj/instagram.svg";


export default function Home() {
  return (
    <main className="home">
      <div className="home__body">
        <section className="home__main main">
          <div className="main__container parallax">
            <div className="main__decoration decoration">
              <img src={salaOgrodowa} className="decoration__image"></img>
            </div>
            <div className="main__block block">
              <h1 className="block__title">STUDIO FOTOGRAFICZNE LABIRYNT</h1>
              <div className="block__text">
                <p>
                  Ekskluzywne studio fotograficzne we Wrocławiu z pełnym
                  wyposażeniem. Wykonasz tu zjawiskowe sesje zdjęciowe,
                  nakręcisz materiał wideo czy zorganizujesz warsztaty
                  fotograficzne.
                </p>

                <p>
                  Do dyspozycji są cztery przestronne sale studyjne o
                  niespotykanym charakterze i aranżacjach. Każdą z sal
                  studyjnych jest do wynajęcia na godziny.
                </p>

                <p>
                  W studiu do dyspozycji jest profesjonalny sprzęt
                  fotograficzny, dzięki któremu wykonasz tu każdego typu sesje z
                  łatwością i w krótszym czasie.
                </p>
              </div>
              <button className="block__button">Dowiedz się więcej! </button>
            </div>
          </div>
        </section>
        <section className="home__statistics statistics">
          <div className="statistics__container">
            <div className="statistics__blocks blocks">
              <div className="blocks__block blocks__block_1 block">
                <div className="block__number">4</div>
                <div className="block__under-text">
                  sale studyjne z profesjonalnym sprzętem
                </div>
                <div className="block__text">
                  Nasze sale są wyposażone w{" "}
                  <span>najnowocześniejszy sprzęt</span>, który spełni
                  oczekiwania nawet najbardziej wymagających{" "}
                  <span>fotografów</span>. Tu odkryjesz przestrzeń, gdzie
                  kreatywność spotyka się z technologią.
                </div>
              </div>
              <div className="blocks__block blocks__block_2 block">
                <div className="block__number">3</div>
                <div className="block__under-text">rodzaje oświetlenie</div>
                <div className="block__text">
                  Oferujemy szeroką gamę <span>lamp błyskowych</span> i{" "}
                  <span>światła ciągłego</span>, dzięki którym stworzysz
                  dokładnie to czego oczekujesz od swoich projektów.{" "}
                  <span>Mamy też duże okna</span> z pięknym światłem dziennym.
                </div>
              </div>
              <div className="blocks__block blocks__block_3 block">
                <div className="block__number">7</div>
                <div className="block__under-text">dni w tygodniu</div>
                <div className="block__text">
                  Jesteśmy otwarci codziennie, by wspierać Twoje potrzeby
                  fotograficzne. Wybierz nasze usługi i korzystaj z
                  profesjonalnego wsparcia w każdym momencie.
                </div>
              </div>
              <div className="blocks__block blocks__block_1 block">
                <div className="block__number">5</div>
                <div className="block__under-text">
                  powodów bywybrać nasze studio
                </div>
                <div className="block__text">
                  <ul>
                    <li>Profesjonalne wyposażenie</li>
                    <li>Lokalizacja</li>
                    <li>Elastyczny wynajem</li>
                    <li>Kreatywne środowisko</li>
                    <li>Komfortowa przestrzeń</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home__equipment equipment">
          <div className="equipment__container">
            <div className="equipment__content content">
              <div className="content__header">Sprzęt fotograficzny</div>
              <h2 className="content__title">
                Wyposażenie studia fotograficznego
              </h2>
              <div className="content__text">
                Wynajmiesz sale studyjne wraz ze sprzętem, którym wykonasz
                profesjonalne sesje zdjęciowe bez względu czy jesteś zawodowcem
                czy początkującym amatorem fotografii.
              </div>
              <button className="content__button">Sprawdź szczegóły</button>
            </div>
            <div className="equipment__blocks blocks">
              <div className="blocks__block blocks__block_1 block">
                <h4 className="block__title">Lampy</h4>
                <div className="block__text">
                  Idealne do precyzyjnego kształtowania oświetlenia na planie
                  zdjęciowym i filmowym. Zapewniamy światło błyskowe i ciągłe.
                </div>
              </div>
              <div className="blocks__block blocks__block_2 block">
                <h4 className="block__title">Softboxy</h4>
                <div className="block__text">
                  Klucz do wyjątkowego doświetlenia każdej fotografii studyjnej.
                  Zapewnimy Ci pokaźny wybór modyfikatorów światła.
                </div>
              </div>
              <div className="blocks__block blocks__block_3 block">
                <h4 className="block__title">Statywy</h4>
                <div className="block__text">
                  Solidne statywy oświetleniowe renomowanych producentów.
                  C-standy, boomy, wind-up'y.
                </div>
              </div>
              <div className="blocks__block blocks__block_4 block">
                <h4 className="block__title">Tła</h4>
                <div className="block__text">
                  To idealne wypełnienie każdej fotografii portretowej, która ma
                  w cobie "to coś". W cenie tła kartonowe 2,7m i canvas 2m
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home__studio studio">
          <div className="studio__container">
            <div className="studio__half-body studio__half-body_1 half-body">
              <div className="half-body__text-block">
                <div className="half-body__header">odkryj Labirynt</div>
                <h2 className="half-body__title">Wyjątkowe Studio na sesje</h2>
              </div>
              <div className="half-body__image-block image-block">
                <img src={salaBalowa} className="image-block__image"></img>
                <h5 className="image-block__image-title">Sala balowa</h5>
              </div>
              <div className="half-body__image-block image-block">
                <img src={salaTarasowa} className="image-block__image"></img>
                <h5 className="image-block__image-title">Sala tarasowa</h5>
              </div>
            </div>
            <div className="studio__half-body studio__half-body_2 half-body">
              <div className="half-body__image-block image-block">
                <img src={salaKominkowa} className="image-block__image"></img>
                <h5 className="image-block__image-title">Sala kominkowa</h5>
              </div>
              <div className="half-body__image-block image-block">
                <img src={salaOgrodowa} className="image-block__image"></img>
                <h5 className="image-block__image-title">Sala ogrodowa</h5>
              </div>
              <div className="half-body__text-block half-body__text-block_2">
                <h3 className="half-body__title">
                  Wynajmij studio fotograficzne już teraz
                </h3>
                <button className="half-body__button">Rezerwacje</button>
              </div>
            </div>
          </div>
        </section>
        <section className="home__atelier atelier">
          <div className="atelier__container">
            <div className="atelier__header">Cztery oblicza przestrzeni</div>
            <h2 className="atelier__title">Atelier dla Twojej wizji</h2>
            <div className="atelier__blocks blocks">
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaBalowaAlt} alt="Sala balowa"></img>
                </div>
                <h4 className="block__title">Studio 1 "Sala balowa"</h4>
                <div className="block__text">
                  Największa sala naszego studia fotograficznego. Jej cechą
                  charakterystyczną jest piękny fortepian w kolorze brązowym.
                  Ponad to znaleźć tu można wiele unikalnych dodatków, które
                  nadają Waszym dziełom charakteru i elegancji. Stylowy klimat i
                  miejsce, które ma swoją historię.
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaKominkowaAlt} alt="Sala kominkowa"></img>
                </div>
                <h4 className="block__title">Studio 2 "Sala kominkowa"</h4>
                <div className="block__text">
                  Cała w drewnie, z kominkiem, wyjątkową podłogą o szczotkowanej
                  strukturze. Kominek kojarzy się z romantyzmem, umieszczenie go
                  w kadrze może dodać zdjęciu głębi i emocji. Zdjęcia z
                  kominkiem przenoszą do czasów innej epoki, a nawet w inny
                  wymiar. Ta sala idealnie się nadaje do sesji wizerunkowych,
                  kobiecych czy sezonowych (aranżacja świąteczna).
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaOgrodowaAlt} alt="Sala ogrodowa"></img>
                </div>
                <h4 className="block__title">Studio 3 "Sala ogrodowa"</h4>
                <div className="block__text">
                  Posiada marmurową wannę na lwich łapach oraz mniejsze
                  aranżacje i duże lustro. Sala ogrodowa połączona jest z
                  ogrodem zimowym, w którym znajdują się duże okna, dzięki temu
                  mamy światła. Okna (otwierane pionowo) mogą też stanowić
                  ciekawy element kompozycji, tworząc kontrast między wnętrzem a
                  zewnętrzem, lub służyć jako ramy dla modeli. Sala ma piękny
                  francuski balkonik, podwójnie rozsuwane drzwi i „lewitujące”
                  kwiaty.
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaTarasowaAlt} alt="Sala tarasowa"></img>
                </div>
                <h4 className="block__title">Studio 4 "Sala tarasowa"</h4>
                <div className="block__text">
                  Minimalistyczna sala z parkietem, z dużą ilością płóciennych
                  teł Canvas ręcznie malowanych, szezlongiem czy antyczną
                  witryną. Idealne miejsce do tworzenia nastrojowych i
                  artystycznych zdjęć portretowych. Sala z otwartym tarasem
                  zapewnia pełen dostęp do promieni słonecznych, co pozwala na
                  uzyskanie naturalnego i ciepłego oświetlenia zdjęć.
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home__reviews reviews">
          <div className="reviews__container">
            <div className="reviews__rozwoj rozwoj">
              <div className="rozwoj__header">Rozwój</div>
              <h3 className="rozwoj__title">Warsztaty fotograficzne</h3>
              <div className="rozwoj__text">
                <p>
                  W studiu Labirynt{" "}
                  <span>organizowane są cyklicznie warsztaty i szkolenia</span>{" "}
                  dla fotografów. To świetna szansa do rozwoju panowania nad
                  światłem w studiu fotograficznym. Dodatkowo rozbudujesz swoje
                  portfolio w krótkim czasie o wiele różnych ujęć.
                </p>
                <p>
                  Współpracujemy ze znanymi fotografami, którzy również
                  organizują u nas swoje warsztaty.
                </p>
                <p>
                  Wszystkie aktualne informacje o warsztatach, kursach i
                  szkoleniach z fotografii studyjnej znajdziesz na naszych
                  profilach społecznościowych.
                </p>
                <p>
                  Chcesz zorganizować warsztaty w naszym studiu? Skontaktuj się
                  z nami – przygotujemy ofertę specjalnie dla Ciebie.
                </p>
              </div>
            </div>
            <div className="reviews__opinie opinie">
              <h3 className="opinie__title">Opinie Studia Labirynt :</h3>
              <div className="opinie__text">
                "Studio zdecydowanie warte polecenia! Sprzęt dostępny na miejscu
                (pierwsza klasa! Bardzo duży wybór) i urządzenie pokoi daje
                naprawdę wieeeele możliwości. Pomysły same się rodzą w takim
                otoczeniu :)) atutem miejsca, poza jego przestrzenią i
                wyrazistością, jest bardzo pomocny i znający się na rzeczy Pan
                Marcin Pozdrawiam serdecznie!"
              </div>
              <div className="opinie__map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2506.4755335065965!2d17.00208861281098!3d51.081230971601656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc3d63af9167d%3A0x2829f0aab9b5d3bf!2sLabirynt%20Studio%20Fotograficzne%20na%20wynajem%20Wroc%C5%82aw!5e0!3m2!1sen!2spl!4v1737115226295!5m2!1sen!2spl"
                  width="100%"
                  height="100%"
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <section className="home__obzerwuj obzerwuj">
          <div className="obzerwuj__container">
            <div className="obzerwuj__content content">
              <h3 className="content__title">Obserwuj studio!</h3>
              <div className="content__text">Wszystkie świeże informacje i nowości o naszym studiu fotograficznym znajdziesz na naszych profilach społecznościowych. Dodatkowo garść inspiracji czy pomysłów na sesje.</div>
              <div className="content__links">
                <a href="https://www.facebook.com/studio.labirynt">
                  <img src={facebookSvg} alt="facebook"></img>
                </a>
                <a href="https://www.instagram.com/labirynt.studio/#">
                  <img src={instagramSvg} alt="instagram"></img>
                </a>
              </div>
            </div>
            <div className="obzerwuj__image">
              <img src={obzerwujLight} alt="obzerwuj"></img>
            </div>
          </div>
        </section>
        <section className="home__wiecej wiecej">
          <div className="wiecej__container">
            <h2 className="wiecej__title"></h2>
            <div className="wiecej__text"></div>
          </div>
        </section>
      </div>
    </main>
  );
}
